import classNames from 'classnames';
import * as React from 'react';

export const EmptyStateDashboard = ({
  src,
  contents,
  className,
  wrapperClass,
  textWrapperClass,
}: {
  src: string;
  contents: string[];
  className?: string;
  wrapperClass?: string;
  textWrapperClass?: string;
}) => {
  const imageClasses = classNames({
    'mb-8 mx-auto': true,
    [className || '']: !!className,
  });

  return (
    <div
      className={`flex justify-center text-center bg-white p-24 text-gray-999 w-full ${wrapperClass}`}
    >
      <div className="min-h-144 text-sm justify-center">
        <img src={src} width="304px" height="150px" className={imageClasses} alt="" />
        {contents.map((obj, index) => (
          <p key={`${obj}${index}`} className={`${textWrapperClass}`}>
            {obj}
          </p>
        ))}
      </div>
    </div>
  );
};
